<template>
  <app-layout :title="title">
    <template #header>
      <div class="flex w-full justify-between items-center">
        <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none" v-html="title">
        </h2>
        <div class="flex gap-x-2 md:gap-x-10">
          <app-useful-links :items="usefulLinks" />
          <a :href="`/admin/brand-monitoring/mention/${model.id}/remove`">
            <button class="h-[42px] px-4 rounded-md text-red-500 border border-red-500 hover:bg-red-100 transition">
              Remove
            </button>
          </a>

        </div>
      </div>
    </template>

    <div class="mx-auto py-4">

      <div class="w-full">
        <nav class="border-b text-sm flex justify-start overflow-scroll">
          <a :class="{
            'inline-block py-2 mr-4 text-slate-600 hover:text-slate-900': true,
            'border-b-2 border-orange-600': tab === 1,
          }" href="#" @click.prevent="currentTab(1)">
            Data
          </a>
          <a :class="{
            'inline-block py-2 mr-4 text-slate-600 hover:text-slate-900': true,
            'border-b-2 border-orange-600': tab === 2,
          }" href="#" @click.prevent="currentTab(2)">
            System
          </a>
        </nav>

        <div class="pt-10">
          <div v-if="tab === 1">
            <form @submit.prevent="submit">
              <div class="grid grid-cols-6 gap-6">

                <div class="col-span-6">
                  <jet-label for="date" value="Date" />
                  <jet-input id="date" type="text" class="block w-full mt-1" v-model="form.date" />
                  <jet-input-error :message="form.errors.date" class="mt-2" />
                </div>

                <div class="col-span-6">
                  <jet-label for="title" value="Title" />
                  <jet-input id="title" type="text" class="block w-full mt-1" v-model="form.title" maxlength="400"
                    autofocus />
                  <jet-input-error :message="form.errors.title" class="mt-2" />
                </div>

                <div class="col-span-6">
                  <jet-label for="text" value="Text" />
                  <jet-input id="text" type="text" class="block w-full mt-1" v-model="form.text" maxlength="400"
                    autofocus />
                  <jet-input-error :message="form.errors.text" class="mt-2" />
                </div>

                <div class="col-span-6">
                  <jet-label for="url" value="Url" />
                  <jet-input id="url" type="text" class="block w-full mt-1" v-model="form.url" maxlength="400"
                    autofocus />
                  <jet-input-error :message="form.errors.url" class="mt-2" />

                  <a class="mt-[10px] size-[30px] bg-slate-300 flex items-center justify-center cursor-pointer hover:bg-teal-950 transition-all duration-150"
                    :href="form.url" target="_blank">
                    ЖМИ!
                  </a>

                </div>

                <div class="col-span-6">

                  <image-editor name="cover" label="Cover" desc="" :value="form.cover" :validation-rules="{
                    accept: ['image/png', 'image/jpeg', 'image/gif'],
                    maxSizeInKB: 100000,
                  }" @update="onChangeUniversalNEW('cover', $event)"></image-editor>

                </div>

                <div class="col-span-6">
                  <jet-label for="is_official" value="is_official" />
                  <label class="flex items-center mt-2">
                    <jet-checkbox v-model:checked="form.is_official" />
                    <span class="ml-2 text-sm text-slate-600">Да</span>
                  </label>
                </div>

                <div class="col-span-6">
                  <jet-label for="is_guide" value="is_guide" />
                  <label class="flex items-center mt-2">
                    <jet-checkbox v-model:checked="form.is_guide" />
                    <span class="ml-2 text-sm text-slate-600">Да</span>
                  </label>
                </div>

                <div class="col-span-6">
                  <jet-label for="attention" value="attention" />
                  <label class="flex items-center mt-2">
                    <jet-checkbox v-model:checked="form.attention" />
                    <span class="ml-2 text-sm text-slate-600">Да</span>
                  </label>
                </div>

                <div class="col-span-6">
                  <jet-label for="verified" value="verified" />
                  <label class="flex items-center mt-2">
                    <jet-checkbox v-model:checked="form.verified" />
                    <span class="ml-2 text-sm text-slate-600">Да</span>
                  </label>
                </div>

                <div class="col-span-6">
                  <a :href="`/admin/brand-monitoring/platform/${form.platform_id}`">
                    <pre class="min-w-[100px] min-h-[100px] bg-yellow-300">Platform #{{ form.platform_id }}</pre>
                  </a>
                </div>

              </div>

              <div class="flex items-center justify-start pt-8">
                <jet-button :disabled="form.processing">Сохранить</jet-button>
                <jet-action-message :on="form.recentlySuccessful" class="ml-3">Сохранено.</jet-action-message>
              </div>
            </form>
          </div>
          <div v-if="tab === 2">
            <pre class="bg-red-500 text-white size-[700px]">{{ props }}</pre>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>


<script setup>
import { ref } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetActionMessage from '@/Jetstream/ActionMessage.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import AppUsefulLinks from '@/Components/usefulLinks.vue';
import ImageEditor from '@/Components/ImageEditor.vue';

const props = defineProps({
  model: Object,
  platform: Object,
  prefixRoute: String,
  title: String,
  usefulLinks: Object,
});

const tab = ref(1)
const currentTab = (tabNumber) => (tab.value = tabNumber);

const beingDeleted = ref(null);
const confirmDeletion = (id) => {
  beingDeleted.value = id;
};

const form = useForm({ ...props.model });

const submit = () => {
  form.put(route(`${props.prefixRoute}.update`, props.model.id));
};

const onChangeUniversalNEW = function (name, img) {
  form[name] = img.value;
};

const deleteQuery = () => {
  form.delete(route(`${props.prefixRoute}.destroy`, props.model.id), {
    onSuccess: () => (beingDeleted.value = null),
  });
};
</script>

<style>
@import 'media-library-pro-styles';

.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}

.thumb {
  width: 4rem !important;
  height: 4rem !important;
  object-fit: cover !important;
}

.media-library-thumb {
  width: 10rem !important;
  height: 10rem !important;
  margin: 4rem;
}
</style>
